import React from "react";
import { useNavigate } from "react-router-dom";



export default function GardenDailyWorkCard({ count, title, navLink, cardName, imgPath, DailyPreventiveWorkNavigate,ApiFlag }) {
    const navigate = useNavigate()

    const handleGardenDailyWorkCard = () => {
        navigate(navLink)
    }
    return (
        <div style={{ cursor:'pointer' }} className="mb-1 p-3 shadow blue_borders bg-white mb-md-2 daily-card-width" onClick={() => DailyPreventiveWorkNavigate(title,ApiFlag)}>
            <div className="d-flex flex-column justify-content-between" style={{ height: '100%' }}>
                <div className="text-center" >
                    <div className="d-flex justify-content-between align-items-center pb-3">
                        <h4>{count}</h4>
                        <img className={cardName} style={{ height: '50px', width: '35px' }} src={imgPath} alt="" />
                    </div>

                </div>
                <div className="" style={{ borderLeft: '2px solid #d6bea7' }}>
                    <h6 className="text-black ml-3"><b>{title}</b></h6>
                </div>
            </div>
        </div>
    )
}